import React from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import ModalLegales from '../ModalLegales/ModalLegales';

const Container = styled.p`
	${props => props.$isContainerTelcel && 
		css`
			font-family: AMX-Regular;
			font-size: 12px;
			color: #222;
			line-height: 22px;
			margin: 0px;
			padding: calc(24px - 2%) 2% 2px 2%;
		`
	}

	${props => !props.$isContainerTelcel && 
		css`
			font-family: AMX-Regular;
			font-size: 12px;
			color: #222;
			line-height: 22px;
			margin: 0px;
			padding: calc(24px - 2%) 2% 2px 2%;
		`
	}
`;

const Text = styled.span`
	${props => props.$isContainerTelcel && 
		css`
			font-family: ${props.$bold ? "AMX-Bold" : "AMX-Regular"};
			color: ${props.$color || "#222"};
			display: ${props.$display || "inline"};
			text-decoration: ${props.$textDecoration || "none"}
		`
	}

	${props => !props.$isContainerTelcel && 
		css`
			font-family: ${props.$bold ? "AMX-Bold" : "AMX-Regular"};
			color: ${props.$color || "#222"};
			display: ${props.$display || "inline"};
			text-decoration: ${props.$textDecoration || "none"}
		`
	}
`;

const TermsAndPrivacy = ({
	isContainerTelcel,
}) => {
	const [open, setOpen] = React.useState(false);
	const [url, setUrl] = React.useState("");

	const handleOnClick = (option="") => {
		if (option === "privacy") {
			setUrl(
				isContainerTelcel 
					? process.env.REACT_APP_PRIVACY_TELCEL_FORM_URL 
					: process.env.REACT_APP_PRIVACY_TELCEL_FORM_URL
			);
		}
		if (option === "terms") {
			setUrl(
				isContainerTelcel 
					? process.env.REACT_APP_TERMS_TELCEL_FORM_URL
					: process.env.REACT_APP_TERMS_TELCEL_FORM_URL
			);
		}
		setOpen(!open);
	}

	return (
		<>
			<Container $isContainerTelcel={isContainerTelcel}>
				Al presionar&nbsp;
				<Text 
					$isContainerTelcel={isContainerTelcel}
					$bold={true}>
					‘Pagar’
				</Text>, estás aceptando el&nbsp;
				<Text
					$isContainerTelcel={isContainerTelcel}
					$bold={true}
					$display="inline-block"
					$textDecoration="underline"
					$color="#0071D1"
					onClick={() => handleOnClick("privacy")}>
					Aviso de Privacidad
				</Text>&nbsp;
				<br />
				y los&nbsp;
				<Text
					$isContainerTelcel={isContainerTelcel}
					$bold={true}
					$display="inline-block"
					$textDecoration="underline"
					$color="#0071D1"
					onClick={() => handleOnClick("terms")}>
					Términos y Condiciones
				</Text> 
				&nbsp;de la app
			</Container>

			{
				open &&
				<ModalLegales 
					url={url}
					handleOnClick={handleOnClick}
				/>
			}
		</>
		
	)
}

const mapStateToProps = (state) => {
	const { payments } = state;
	const isContainerTelcel = payments.isContainerTelcel;
	return {
		isContainerTelcel,
	}
}

export default connect(mapStateToProps)(TermsAndPrivacy);